import { createContext, useContext, useEffect } from 'react'
import type { AiAgentContextValue } from './utils/types'

export const AiAgentContext = createContext<AiAgentContextValue | undefined>(undefined)

export const useAiAgent = (): AiAgentContextValue => {
  const context = useContext(AiAgentContext)
  if (!context) {
    throw new Error('useAiAgent must be used within an AiAgentProvider')
  }
  return context
}

export const usePageIsAiReady = () => {
  const { isPageAiReady, setPageAiReady } = useAiAgent()

  useEffect(() => {
    setPageAiReady(true)

    return () => {
      setPageAiReady(false)
    }
  }, [isPageAiReady, setPageAiReady])

  return isPageAiReady
}
